import React from 'react'

import { Grid, Paper, Typography } from '@mui/material'

const EquipmentRequestItem = ({ title, subTitle }) => {
    return (<Paper variant='outlined' sx={{ padding: 2, marginBottom: 2 }}>
        <Grid container spacing={2}>
            <Grid item xs={6}><Typography variant="h6">{title}</Typography></Grid>
            <Grid item xs={6} textAlign={'right'}><Typography variant="subtitle1">{subTitle}</Typography></Grid>
        </Grid>
    </Paper>)
}

export default EquipmentRequestItem